import type { ReactNode } from 'react';
import { createContext } from 'react';

export type PageSidebarSlot = {
  content: ReactNode;
  appearance?: {
    bgcolor?: string;
    borderColor?: string;
  };
};

interface PageLayoutSlots {
  pageHeaderSlot: ReactNode;
  pageSidebarSlot: PageSidebarSlot | null;
}

interface PageLayoutActions {
  setPageHeaderSlot: (node: ReactNode) => void;
  setPageSidebarSlot: (slot: PageSidebarSlot | null) => void;
  setPageContentTop: (top: number) => void;
}
// For reading slot content (used by layout components)
export const PageLayoutSlotContext = createContext<PageLayoutSlots>({
  pageHeaderSlot: null,
  pageSidebarSlot: null,
});

// For writing slot content (used by pages via hooks)
export const PageLayoutContext = createContext<PageLayoutActions>({
  setPageHeaderSlot: () => {},
  setPageSidebarSlot: () => {},
  setPageContentTop: () => {},
});

/**
 * Distance in px from the viewport top to the page content area (the row below
 * the page header). Measured once by `PageContentRow` and consumed by
 * `SidePanel` (fixed) and `Sidebar` (viewport-bound height) so neither has to
 * measure the header itself. `0` until measured / outside a `<Page>`.
 */
export const PageContentTopContext = createContext<number>(0);
